module.exports = __webpack_public_path__ + "static/media/cloneFailedImage.c1b577c2.svg";